import { ChangeDetectorRef, Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { first } from 'rxjs/operators';
import { InsuranceService } from 'src/app/Services/insurance.service';
import { AuthService } from '../../auth/AuthService';
import { ProviderService } from '../../Services/provider.service';
import swal from 'sweetalert2';

type PastingLogType = 'start' | 'end' | 'info' | 'error';

@Component({
  selector: 'pm-pasting',
  templateUrl: './pasting.component.html',
  styleUrls: ['./pasting.component.css']
})
export class PastingComponent implements OnInit, OnDestroy {
  OfficeType: any[] = [];
  selectedInsurance: string | null = null;
  selectedReportMode: 'single' | 'multiple' = 'single';
  pastingLogs: Array<{ time: string; message: string; type: PastingLogType }> = [];
  pastingRunning = false;
  private clientSub: any;

  readonly insuranceOptions = [{ name: 'DENTICON', value: 'DENTICON' }];
  readonly reportModeOptions = [
    { name: 'Single', value: 'single' },
    { name: 'Multiple', value: 'multiple' }
  ];

  constructor(
    private insuranceServices: InsuranceService,
    public authService: AuthService,
    private providerServices: ProviderService,
    private ngZone: NgZone,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
  
  }

  ngOnDestroy(): void {
    this.clientSub?.unsubscribe();
  }



  runPasting(): void {
    const clientId = this.authService.clientId;

    if (!clientId || !this.selectedInsurance || !this.selectedReportMode || this.pastingRunning) {
      return;
    }


    this.ngZone.run(() => {
      this.pastingRunning = true;
      this.addLog(`Pasting started`, 'start');
      this.addLog('Using local Denticon folder. No browser file upload is required.', 'info');
      this.addLog(`Report mode: ${this.selectedReportMode}.`, 'info');
      this.cdr.detectChanges();
    });

    this.insuranceServices
      .runPasting(null, clientId, this.selectedInsurance, null, this.selectedReportMode)
      .subscribe(
        () => {
          this.ngZone.run(() => {
            this.pastingRunning = false;
            this.addLog('Pasting request submitted successfully.', 'end');
            this.addLog('Frontend request completed. Backend processing logs will be integrated when the log API is available.', 'info');
            this.cdr.detectChanges();
          });
        },
        (error: any) => {
          this.ngZone.run(() => {
            this.pastingRunning = false;

            const message =
              error?.error?.message ||
              error?.error ||
              'Pasting request failed.';

            this.addLog(
              typeof message === 'string' ? message : 'Pasting request failed.',
              'error'
            );

            this.cdr.detectChanges();

            swal.fire({
              title: 'Error!',
              icon: 'error',
              text: typeof message === 'string' ? message : 'Pasting request failed.',
              showConfirmButton: false,
              timer: 5000
            });
          });
        }
      );
  }

  clearLogs(): void {
    this.pastingLogs = [];
  }

  private addLog(message: string, type: PastingLogType): void {
    this.pastingLogs.unshift({
      time: new Date().toLocaleString(),
      message,
      type
    });
  }

}
